<div id="dashboard-container">
  <!-- <img id="thrive-logo" src="/assets/images/thrive-logo.webp" width="709" height="auto" /> -->
  Home page
</div>
